import React from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

export default function UserFormGroup({inputType, label, name, placeholder, handleChange, value, className, editMode, handleClick, disabled}) {
  let input
  if (editMode) {
    input = (
      <Input
        type={inputType}
        id={name}
        name={name}
        placeholder={placeholder}
        onChange={(e) => handleChange(e)}
        className={className}
        value={value}
        disabled={!!disabled}
      />
    )
  } else {
    input = <p className='form-control-static m2clickable' onClick={() => handleClick()}>{value}</p>
  }

  return (
    <FormGroup>
      <Label 
        htmlFor={name} 
        onClick={editMode ? null : () => handleClick()}
        className={editMode ? '' : 'm2clickable'}
        ><b>{label}:</b></Label>
      {input}
    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/UserFormGroup.js